import { supabase } from './supabaseClient';

const BUCKET = 'audio-recordings';
const CLOUD_AUDIO_LIMIT_PREMIUM = 50;
const CLOUD_AUDIO_LIMIT_FREE    = 3;

/** mimeType から拡張子を取得 */
function getExt(mimeType) {
  return mimeType?.includes('mp4') ? 'mp4' : 'webm';
}

/** 音声blobをSupabase Storageにアップロード（ログイン済みユーザー） */
export async function uploadAudio(recordId, blob, childId, mimeType, isPremium = false) {
  if (!childId) return false;
  const ext = getExt(mimeType);
  const path = `${childId}/${recordId}.${ext}`;
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, blob, { contentType: mimeType || 'audio/webm', upsert: true });
  if (error) {
    console.warn('音声クラウドアップロードエラー:', error);
    return false;
  }
  // 件数制限：古いものを削除（プレミアム20件、無料3件）
  const limit = isPremium ? CLOUD_AUDIO_LIMIT_PREMIUM : CLOUD_AUDIO_LIMIT_FREE;
  await enforceLimit(childId, limit);
  return true;
}

/** 上限を超えた古いファイルを削除 */
async function enforceLimit(childId, limit) {
  const { data } = await supabase.storage
    .from(BUCKET)
    .list(childId, { sortBy: { column: 'created_at', order: 'asc' } });
  if (!data || data.length <= limit) return;
  const toDelete = data
    .slice(0, data.length - limit)
    .map((f) => `${childId}/${f.name}`);
  await supabase.storage.from(BUCKET).remove(toDelete);
}

/** 署名付きURL取得（1時間有効）。webm→mp4の順で試す */
export async function getAudioSignedUrl(recordId, childId) {
  if (!childId) return null;
  for (const ext of ['webm', 'mp4']) {
    const path = `${childId}/${recordId}.${ext}`;
    const { data } = await supabase.storage
      .from(BUCKET)
      .createSignedUrl(path, 3600);
    if (data?.signedUrl) return data.signedUrl;
  }
  return null;
}

/** child_idに紐づくクラウド保存済み録音IDの一覧を取得 */
export async function getCloudAudioIds(childId) {
  if (!childId) return [];
  const { data, error } = await supabase.storage
    .from(BUCKET)
    .list(childId);
  if (error || !data) return [];
  return data.map((f) => f.name.replace(/\.(webm|mp4)$/, ''));
}

/** クラウド音声を削除 */
export async function deleteCloudAudio(recordId, childId) {
  if (!childId) return;
  for (const ext of ['webm', 'mp4']) {
    await supabase.storage
      .from(BUCKET)
      .remove([`${childId}/${recordId}.${ext}`]);
  }
}

/** childIdに紐づくクラウド音声をすべて削除（プロフィール削除時に呼ぶ） */
export async function deleteAllChildAudio(childId) {
  if (!childId) return;
  const { data, error } = await supabase.storage
    .from(BUCKET)
    .list(childId);
  if (error || !data || data.length === 0) return;
  const paths = data.map((f) => `${childId}/${f.name}`);
  await supabase.storage.from(BUCKET).remove(paths);
}
